import React from "react";
import ReactDOM from "react-dom/client";
import { initializeIcons } from "@fluentui/react";
import { InteractionRequiredAuthError, PublicClientApplication } from "@azure/msal-browser";
import { callMsGraph, getEnvironmentApi, personalSettingsGetApi } from "./api";
import { getMsalConfig } from "./auth/authUtil";
import { updateLoginHistory } from "./services/LoginHistoryService";
import App from "./App";

import "./index.css";
import "github-markdown-css/github-markdown-dark.css";
import "highlight.js/styles/github-dark.css";
import { PermissionError } from "./components/PermissionError";

const environment = await getEnvironmentApi();
const msalConfig = getMsalConfig(environment);
const msalInstance = new PublicClientApplication(msalConfig);

await msalInstance
    .handleRedirectPromise()
    .then(tokenResponse => {
        if (!tokenResponse) {
            const allAccounts = msalInstance.getAllAccounts();
            if (allAccounts.length === 0) {
                msalInstance.loginRedirect();
            }
        } else {
            // Do something with the tokenResponse
        }
    })
    .catch(err => {
        console.log(err);
    });

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    //ログイン後にだけ通るここでログイン履歴を更新する
    const activeAccount = msalInstance.getActiveAccount();
    if (environment.useLoginHistory && activeAccount) {
        const accessTokenRequest = {
            scopes: ["User.Read"],
            account: activeAccount
        };

        const userGraph = await msalInstance
            .acquireTokenSilent(accessTokenRequest)
            .then(response => {
                return callMsGraph(response.accessToken);
            })
            .catch(error => {
                if (error instanceof InteractionRequiredAuthError) {
                    msalInstance.acquireTokenRedirect(accessTokenRequest);
                } else {
                    console.debug("Error occurs(1).");
                }
            });

        if (userGraph !== undefined) {
            const GPT4o_IS_ENABLE = "GPT-5 is available from the administrator settings(1).";
            const GPT4o_IS_DISABLE = "GPT-5 is not available from the administrator settings(1).";
            try {
                await personalSettingsGetApi(userGraph.userPrincipalName).then(personalSettings => {
                    if (personalSettings.status === 200) {
                        const setting = personalSettings.settings;
                        environment.useModelGpt4o = setting.model === "1" ? true : false;
                        console.debug(environment.useModelGpt4o ? GPT4o_IS_ENABLE : GPT4o_IS_DISABLE);
                    } else {
                        environment.useModelGpt4o = false;
                        console.debug(GPT4o_IS_DISABLE);
                    }
                });
            } catch (e) {
                environment.useModelGpt4o = false;
                console.debug("Error orrurs when getting personal settings(1).");
            }
        } else {
            environment.useModelGpt4o = false;
            const MSG_ERR_USERGRAPH = "Error - UserGraph is undefined(1).";
            console.debug(MSG_ERR_USERGRAPH);
        }
        await updateLoginHistory(activeAccount.localAccountId, userGraph !== undefined ? userGraph.userPrincipalName : "");
    }
}

/**
 * 画面表示
 */
let pgaiDisplayPermissionValue: string;
let pgaiDisplayPermissionFlag = false;
const initializeApp = async () => {
    if (environment.useAdminSystem && msalInstance.getActiveAccount()) {
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount) {
            const accessTokenRequest = {
                scopes: ["User.Read"],
                account: activeAccount
            };
            const userGraph = await msalInstance
                .acquireTokenSilent(accessTokenRequest)
                .then(response => {
                    return callMsGraph(response.accessToken);
                })
                .catch(error => {
                    if (error instanceof InteractionRequiredAuthError) {
                        msalInstance.acquireTokenRedirect(accessTokenRequest);
                    } else {
                        console.debug("Error occurs(2).");
                    }
                });

            if (userGraph !== undefined) {
                const GPT4o_IS_ENABLE = "GPT-5 is available from the administrator settings(2).";
                const GPT4o_IS_DISABLE = "GPT-5 is not available from the administrator settings(2).";
                try {
                    await personalSettingsGetApi(userGraph.userPrincipalName).then(personalSettings => {
                        if (personalSettings.status === 200) {
                            const setting = personalSettings.settings;
                            pgaiDisplayPermissionValue = personalSettings.settings.model;
                            environment.useModelGpt4o = setting.model === "1" ? true : false;
                            console.debug(environment.useModelGpt4o ? GPT4o_IS_ENABLE : GPT4o_IS_DISABLE);
                        } else {
                            environment.useModelGpt4o = false;
                            pgaiDisplayPermissionValue = "9";
                            console.debug(GPT4o_IS_DISABLE);
                        }
                        pgaiDisplayPermissionFlag =
                            personalSettings.settings.model !== "9";

                    });
                } catch (e) {
                    environment.useModelGpt4o = false;
                    pgaiDisplayPermissionValue = "9";
                    console.debug("Error orrurs when getting personal settings(2).");
                }
            } else {
                environment.useModelGpt4o = false;
                pgaiDisplayPermissionValue = "9";
                const MSG_ERR_USERGRAPH = "Error - UserGraph is undefined(2).";
                console.debug(MSG_ERR_USERGRAPH);
            }
        }
    }

    initializeIcons('https://res.cdn.office.net/files/fabric-cdn-prod_20240129.001/assets/icons/');
    class ParentComponent extends React.Component<{ instance: any; environment: any }, { showPermissionError: boolean }> {
        constructor(props: { instance: any; environment: any }) {
            super(props);
            this.state = {
                showPermissionError: !pgaiDisplayPermissionFlag
            };
        }
        render() {
            return (
                <React.StrictMode>
                    <div className={`parent-container ${this.state.showPermissionError ? 'disabled' : ''}`}>
                        <App instance={this.props.instance} environment={this.props.environment} />
                    </div>
                    {(this.state.showPermissionError && pgaiDisplayPermissionValue)&& (
                        <PermissionError />
                    )}
                </React.StrictMode>
            );
        }
    }

    const rootElement = document.getElementById('root');
    if (rootElement) {
        ReactDOM.createRoot(rootElement).render(<ParentComponent instance={msalInstance} environment={environment} />);
    } else {
        console.error("Error - Root element not found");
    }
};

initializeApp();